export const DefaultProcessBatchWaitTime = 50;

export const DefaultCooldown = 1000;

export enum BatchRequestError {
  processFailure = 'processFailure',
  unretriableFailure = 'unretriableFailure',
  maxAttemptsReached = 'maxAttemptsReached'
}

export type BatchIdSerializer = (id: number) => string;

export type BatchItemProcessor = (ids: Array<QueueItem>) => Promise<ItemProcessorResult>;

export type FailureCooldownProcessor = (attempts: number) => number;

export type ItemExpirationProcessor = (key: string) => any;

export interface BatchRequestProperties {
  getFailureCooldown: FailureCooldownProcessor;
  maxRetryAttempts: number;
  batchSize: number;
  processBatchWaitTime?: number;
  getItemExpiration?: ItemExpirationProcessor;
}

export interface QueueItem {
  key: string;
  itemId: number;
  retryAttempts: number;
  queueAfter: number;
  startTime: Date;
  resolve: QueueResolver;
  reject: QueueRejecter;
}

export type QueueResolver = (item: any) => any;
export type QueueRejecter = (error: BatchRequestError) => any;

export type ItemProcessorResult = { [key: string]: any };

export interface BatchRequestFactory {}
